export let mailAppName = "FbRW_b";
export default {mailAppName};